/**
 * /auth/entry route — re-renders the existing frontend/app/auth/entry/page.tsx.
 *
 * Imports go through the same compat shims as the Next build:
 *   - @/lib/compat/navigation → next-navigation stub → react-router-dom
 *   - @/lib/profile           → unchanged
 *
 * The page's `finishAuth` does window.location.assign() which works
 * identically in Vite-SPA-land because the entire app re-mounts on the
 * full reload. The /api/auth/token-check fetch is proxied to the Go
 * backend (Phase 1) via vite.config.ts's /api rewrite.
 */
import EntryPageImpl from "@/app/auth/entry/page";

export function AuthEntryPage() {
  return <EntryPageImpl />;
}
